import { createUseStyles } from "react-jss";
type Props = {
  value: "COMMAND" | "AFFECTED" | "FREE" | "ACTIF" | "WAITING";
};

const palette: Record<string, { bg: string; text: string; border: string; dot: string }> = {
  COMMAND:  { bg: "rgba(59,130,246,0.10)",  text: "#2563EB", border: "rgba(59,130,246,0.28)",  dot: "#3B82F6" },
  AFFECTED: { bg: "rgba(34,197,94,0.10)",   text: "#16A34A", border: "rgba(34,197,94,0.28)",   dot: "#22C55E" },
  FREE:     { bg: "rgba(100,116,139,0.10)", text: "#475569", border: "rgba(100,116,139,0.22)", dot: "#94A3B8" },
  ACTIF:    { bg: "rgba(34,197,94,0.10)",   text: "#16A34A", border: "rgba(34,197,94,0.28)",   dot: "#22C55E" },
  WAITING:  { bg: "rgba(245,158,11,0.10)",  text: "#D97706", border: "rgba(245,158,11,0.28)",  dot: "#F59E0B" },
};

const get = (value: string) => palette[value] ?? palette.COMMAND;

const useStyles = createUseStyles({
  container: {
    borderRadius: "999px",
    padding: "5px 12px 5px 10px",
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    backgroundColor: (props: Props) => get(props.value).bg,
    border: (props: Props) => `1px solid ${get(props.value).border}`,
    width: "fit-content",
    textTransform: "uppercase",
    fontFamily: "Poppins-Medium",
    fontSize: "11px",
    letterSpacing: "0.3px",
    lineHeight: "16px",
    color: (props: Props) => get(props.value).text,
    whiteSpace: "nowrap",
    transition: "transform 120ms ease, box-shadow 120ms ease",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: (props: Props) => `0 3px 8px ${get(props.value).border}`,
    },
    "&::before": {
      content: '""',
      width: "7px",
      height: "7px",
      borderRadius: "50%",
      backgroundColor: (props: Props) => get(props.value).dot,
      flexShrink: 0,
      boxShadow: (props: Props) => `0 0 0 2px ${get(props.value).bg}`,
    },
  },
});

export default useStyles;
